const computer = {
			computer 	: "computer",
			manager_id 	: "my_computer",
			color 		: "primary",
			name 		: "my computer",
			text 		: "my computer",
			small 		: false,
			large 		: true,
			states 		: {
				cpu : {
					is_percent 	: true,
					text 		: "cpu",
					percent 	: 0, 
					icon  		: "mdi-thermostat-box",
				},
				ram : {
					is_percent 	: true,
					text 		: "ram",
					percent 	: 0, 
					icon  		: "mdi-thermostat-box",	
				},
				disk : { 
					is_percent 	: true,
					text 		: "disk",
					percent 	: 0, 
					icon  		: "mdi-thermostat-box",
				},
				devices : {			
					
				}
			}
		};
				/*
					device : {
						
					}
				*/
module.exports = {
	/*errors : {
		key 	: "errors",
		text 	: "Errors",		
		...computer,  
	},*/
	my_computer : {
		key 	: "my_computer",
		text 	: "My computer",					 
		...computer,
	},
};